import { render, staticRenderFns } from "./BaseModalError.vue?vue&type=template&id=245dcbca&"
import script from "./BaseModalError.vue?vue&type=script&lang=js&"
export * from "./BaseModalError.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalError.vue?vue&type=style&index=0&id=245dcbca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports